import React from "react";
import {Header} from "./Header";
import {Footer} from "./Footer";
import {Outlet} from "react-router-dom";

export const Layout: React.FC = (props) => {
    return <div id={"layout"}>
        <Header/>
        <div className={"pt-[181px] xl:pt-[204px] pb-[.5rem] bg-[#F0F2F5]"}>
            <Outlet {...props}/>
        </div>
        <Footer/>
    </div>
}
